import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Table from '../ogComponent/table';
import Spinner from '../ogComponent/spinner';

export default function RoleDetails() {
  const { id } = useParams();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRoleDetails = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem("accessToken");
      
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/common/roles/${id}/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setRole(response.data);
      } catch (err) {
        console.error("Error fetching role details:", err);
        setError("Failed to load role details.");
      } finally {
        setLoading(false);
      }
    };

    fetchRoleDetails();
  }, [id]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowClick = (item)=>{
    navigate(`/user/empdetails/${item.id}`)
  }

  const headers = [
    { name: "id", label: "ID", active: true },
    { name: "name", label: "Name", active: true },
    { name: "employee_code", label: "Employee Code", active: true },
    { name: "email", label: "Email", active: true },
    { name: "branch", label: "Branch", active: true },
  ];

  const formattedUsers = role?.users?.map((user) => ({
    id: user.id,
    name: user.name || '-',
    employee_code: user.employee_code || '-',
    email: user.email || '-',
    branch: user.branch?.branch_name || '-',
  })) || [];

  if (error) {
    return <div className="text-danger text-center mt-5">{error}</div>;
  }

  return (
    <div className="container py-4">
      {loading ? (
        <Spinner />
      ) : role ? (
        <>
          <h2>{role.role_name}</h2>
          <div className="mt-4">
            <h5>Users</h5>
            {formattedUsers.length > 0 ? (
              <Table
                header={headers}
                product={formattedUsers}
                onRowClick={handleRowClick}
                loading={loading}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : (
              <p>No users assigned to this role.</p>
            )}
          </div>
        </>
      ) : (
        <p>No role data available.</p>
      )}
    </div>
  );
}